import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { WEBApi } from '../API/WEBApi';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Pagination } from 'react-bootstrap';

interface Recognition {
    _id: string;
    title: string;
    date: string;
    content: string;
    image?: string;
    published: boolean;
    orderNo: number; // <-- Added
}

const Recognitions: React.FC = () => {
    const [recognitions, setRecognitions] = useState<Recognition[]>([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const fetchRecognitions = async (currentPage: number) => {
        try {
            setLoading(true);
            const res = await WEBApi.getRecognitions(currentPage);
            setRecognitions(res.recognitions);
            setTotalPages(res.totalPages);
        } catch (error) {
            console.error('Error fetching recognitions:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRecognitions(page);
    }, [page]);

    const handleDelete = async (id: string) => {
        if (!window.confirm('Are you sure you want to delete this recognition?')) return;
        try {
            await WEBApi.deleteRecognition(id);
            const updated = await WEBApi.getRecognitions(page);
            if (updated.recognitions.length === 0 && page > 1) {
                setPage(page - 1);
            } else {
                setRecognitions(updated.recognitions);
                setTotalPages(updated.totalPages);
            }
        } catch (error) {
            console.error('Error deleting recognition:', error);
            alert('Failed to delete recognition. Please try again.');
        }
    };

    const handleEdit = (id: string) => {
        navigate(`/breathe-ev-admin/recognitions/edit/${id}`);
    };

    const renderPagination = () => {
        let items = [];
        for (let number = 1; number <= totalPages; number++) {
            items.push(
                <Pagination.Item
                    key={number}
                    active={number === page}
                    onClick={() => setPage(number)}
                >
                    {number}
                </Pagination.Item>
            );
        }
        return (
            <Pagination className="justify-content-end mt-4">
                <Pagination.Prev onClick={() => setPage(page - 1)} disabled={page === 1} />
                {items}
                <Pagination.Next onClick={() => setPage(page + 1)} disabled={page === totalPages} />
            </Pagination>
        );
    };

    return (
        <main className="container mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3>Recognitions</h3>
                <Link to="/breathe-ev-admin/recognitions/create" className="btn btn-success">
                    Add Recognition
                </Link>
            </div>

            {loading ? (
                <p>Loading recognitions...</p>
            ) : recognitions.length === 0 ? (
                <p>No recognitions found.</p>
            ) : (
                <table className="table">
                    <thead>
                        <tr>
                            <th>Order</th> {/* <-- New column */}
                            <th>Title</th>
                            <th>Image</th>
                            <th>Date</th>
                            <th>Published</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {recognitions.map((recog) => (
                            <tr key={recog._id}>
                                <td>{recog.orderNo ?? '-'}</td> {/* <-- Display orderNo */}
                                <td>{recog.title}</td>
                                <td><img height={50} src={recog.image} /></td>
                                <td>{recog.date}</td>
                                <td>{recog.published ? 'Yes' : 'No'}</td>
                                <td>
                                    <button
                                        className="btn btn-sm btn-warning me-2"
                                        onClick={() => handleEdit(recog._id)}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => handleDelete(recog._id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            {renderPagination()}
        </main>
    );
};

export default Recognitions;
